export const TOAST_TIMEOUT = 5000;

export const NEW_DISCOVER_TIMEOUT = 3600000;
